import axios, { AxiosError } from 'axios';
import { parseAxiosError } from '../common/constant';
import { BASEURL } from './const';

const talkToApi = axios.create()
/* HTTP Request Interceptor to add headers on all API calls */
talkToApi.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        Promise.reject(error);
    }
)

export const getCategories = async(platform:string )=> {
    try{
        const response = await talkToApi.get(`${BASEURL}/messages/categories`,{
            params :{
                platform
            }
        })
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getAIChatHistoryOfIssue = async({issueKey,userId}:{issueKey?:string,userId?:string}) =>{
    try{
        const response = await talkToApi.get(`${BASEURL}/messages`,{
            params :{
                issueKey
            }
        })
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

interface sentMessageToAIParams {
    issueKey:string
    userName:string
    message:string
    platform:string
}
export const sentMessageToAI = async({issueKey,userName,message,platform}:sentMessageToAIParams) =>{
    const payload = {
        issueKey,
        sender:userName,
        message,
        platform,
        response: " "
    }
    try{
        const response = await talkToApi.post(`${BASEURL}/messages`,payload)
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}